// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + ({"56":"offer_page","95":"faq_page","473":"main_page","629":"pricing_page","923":"old_main_page"}[chunkId] || chunkId) + "." + {"56":"bf053b44","95":"2ad7c0bf","100":"31af41a8","147":"c5bd1145","473":"31903c8d","580":"6daa7bf0","629":"2af51aa4","921":"b53d047d","923":"3fab0fc8"}[chunkId] + ".chunk.js";
};